// extracted by mini-css-extract-plugin
export default {"list":"ServiceDescriptionList-module--list--987a5"};